import { Box, Tooltip, useTheme, Theme } from '@material-ui/core'
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons'

const getUtcNoonTimes = () => {
  const now = new Date()
  const year = now.getUTCFullYear()
  const month = now.getUTCMonth()
  const date = now.getUTCDate()
  const nowUtc = Date.UTC(
    year,
    month,
    date,
    now.getUTCHours(),
    now.getUTCMinutes()
  )

  const todayNoon = Date.UTC(year, month, date, 12, 0, 0, 0)
  const yesterdayNoon = Date.UTC(year, month, date - 1, 12, 0, 0, 0)
  const tomorrowNoon = Date.UTC(year, month, date + 1, 12, 0, 0, 0)

  if (nowUtc < todayNoon) {
    return {
      lastRefreshedAt: new Date(yesterdayNoon),
      nextRefreshAt: new Date(todayNoon),
    }
  }

  return {
    lastRefreshedAt: new Date(todayNoon),
    nextRefreshAt: new Date(tomorrowNoon),
  }
}

const formatUtc = (date: Date) =>
  new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  }).format(date) + ' UTC'

const ReportRefreshInfo = (): JSX.Element => {
  const theme: Theme = useTheme()
  const { lastRefreshedAt, nextRefreshAt } = getUtcNoonTimes()

  const tooltipContent = (
    <Box sx={{ fontSize: '12px', lineHeight: 1.6 }}>
      <Box>
        <strong>Next refresh:</strong> {formatUtc(nextRefreshAt)}
      </Box>
      <Box sx={{ marginTop: '6px' }}>
        Meta ad network reporting and attribution can take up to 72 hours.
        Syncing Meta network data may be delayed.
      </Box>
    </Box>
  )

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginBottom: '-8px',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: '12px',
          color: theme.palette.text.secondary,
          lineHeight: '20px',
        }}
      >
        <Box component="span">
          Last refreshed:&nbsp;
          <Box
            component="span"
            sx={{ fontWeight: 600, color: theme.palette.text.primary }}
          >
            {formatUtc(lastRefreshedAt)}
          </Box>
        </Box>
        <Tooltip title={tooltipContent} arrow placement="bottom">
          <InfoOutlinedIcon
            sx={{
              fontSize: '16px',
              marginLeft: '6px',
              color: theme.palette.text.secondary,
              cursor: 'pointer',
            }}
          />
        </Tooltip>
      </Box>
    </Box>
  )
}

export default ReportRefreshInfo
